import { useEffect, useRef } from "react";

const FAST_THRESHOLD = 30; 
const SLOW_THRESHOLD = 60; 
const SLOW_SCROLL_AMOUNT = 10;  
const FAST_SCROLL_AMOUNT = 20; 

export function useAutoScroll(containerRef, isDragging, dragLine) {
  const animationFrameRef = useRef(null);
  const lastScrollTimeRef = useRef(0);

  useEffect(() => {
    if (!isDragging || !dragLine || !containerRef.current) {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
        animationFrameRef.current = null;
      }
      return;
    }

    const container = containerRef.current;
    const containerRect = container.getBoundingClientRect();

    const cursorY = dragLine.end.y - containerRect.top;

    let scrollSpeed = 0;

    if (cursorY < FAST_THRESHOLD) {
      scrollSpeed = -FAST_SCROLL_AMOUNT;
    } else if (cursorY < SLOW_THRESHOLD) {
      scrollSpeed = -SLOW_SCROLL_AMOUNT;
    } else if (cursorY > containerRect.height - FAST_THRESHOLD) {
      scrollSpeed = FAST_SCROLL_AMOUNT;
    } else if (cursorY > containerRect.height - SLOW_THRESHOLD) {
      scrollSpeed = SLOW_SCROLL_AMOUNT;
    }

    if (scrollSpeed !== 0) {
      const scroll = () => {
        const now = Date.now();
        if (now - lastScrollTimeRef.current >= 16) {
          // ~60fps
          const newScrollTop = container.scrollTop + scrollSpeed;
          const maxScroll = container.scrollHeight - container.clientHeight;

          if (newScrollTop >= 0 && newScrollTop <= maxScroll) {
            container.scrollTop = newScrollTop;
          }

          lastScrollTimeRef.current = now;
        }

        if (isDragging) {
          animationFrameRef.current = requestAnimationFrame(scroll);
        }
      };

      animationFrameRef.current = requestAnimationFrame(scroll);
    }

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, [isDragging, dragLine, containerRef]);
}
